/** Created by azhou on 2019/3/18.*/
<template>
  <div class="d-center flex-column">
    <div class="d-center-start mb-3 w-50">
      <left-text leftText="当前邮箱"/> {{userLoginMessage.email || '未绑定邮箱'}}
    </div>
    <left-text-border required class="mb-3 w-50" leftText="新邮箱" v-model="emailNumber"/>
    <div class="d-center-start mb-3 w-50">
      <left-text leftText="验证码" required/>
      <send-phone-code :emailNumber="emailNumber" sendType="email" class="w-100"
                       url="/pc/AuthAndBind/bindEmail"
                       @showError="msg => this._alert(msg,null,'error')"
                       @getCode="code => this.emailCode = code"/>
    </div>
    <el-button type="primary" @click="submitForm">确定</el-button>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'EmailSet',
    computed: {
      ...mapState(['userLoginMessage'])
    },
    data() {
      return {
        emailNumber:'',
        emailCode:''
      }
    },
    methods:{
      ...mapActions(['modifyEmail']),
      submitForm() {
        if (!this.emailNumber || !this.emailCode) {
          this._alert('邮箱号和验证码都不得为空',null,'error');
          return;
        }
        this.modifyEmail({
          //store_id: this.userLoginMessage.store_ids[0],
          email: this.emailNumber,
          code: this.emailCode,
          type: 'bind'
        });
      }
    }
  }
</script>
